import { Injectable } from '@angular/core';
import { EntityType, JkEntityV2,jkLib,dateFormatter, AgComboBoxEditor, } from 'jk-service';
import { AgCheckBoxEditor, AgTextAreaEditor } from 'jk-service';
import { Syska } from '../entity/Syska-angular';




export interface SyskaData {
    COMPANY: string ;
    CREATOR: string;
    USR_GROUP: string ;
    CREATE_DATE: string;
    MODIFIER: string;
    MODI_DATE: string;
    FLAG: number;

    KA001: string;            // 日期 8 定時設定是SYSSE
    KA002: string;            // 時間 12 原本4->12  hh:mm:ss:123
    KA003: string;            // 公司代號 30 DBNAME   OLD:10
    KA004: string;            // 程式代號 20
    KA005: string;            // 保留 10 處理狀態
    KA006: number;            // 處理進度 1 {{0:等待中  1:進行中 5:失敗 9:完成}}
    KA007: string;            // 工作電腦 15
    KA008: string;            // 分類 20 {{批次:批次 報表:報表 API:API批次}}  檔名:KA001+'-'+KA002+'-'+KA004+'.PDF'
    KA009: Date;            // 開始時間 0
    KA010: Date;            // 完成時間 0
    KA011: string;            // 處理結果 0
    KA012: number;            // 錯誤個數 8 XXX 個數
    KA013: number;            // 警告個數 8 WWW 個數
    KA014: string;            // 參數內容 300
    KA015: string;            // 使用者代號 10
    KA016: string;            // 定時工作代號 14 SYSSE.JOBID
    KA017: number;            // 成功筆數 8
    KA018: number;            // 失敗筆數 8
    KA019: string;            // MAIL通知方式 1 {{空白:不通知  1:有錯誤通知 2:有錯誤或警告通知 3:完成就通知}}  <-- SYS.SE116
    KA020: string;            // MAIL帳號 255 可多個MAIL 逗號分開 <-- SYS.SE117
    NAME1: string;            // API名稱 255

}

export const SysKa006List =  [ { id:"0" , name:"等待中" },{ id:"1" , name:"進行中" },{ id:"5" , name:"失敗" },{ id:"9" , name:"完成" } ] ; // 處理進度
export const SysKa008List =  [ { id:"批次" , name:"批次" },{ id:"報表" , name:"報表" },{ id:"API" , name:"API批次" } ] ; // 分類
export const SysKa019List =  [ { id:"空白" , name:"不通知" },{ id:"1" , name:"有錯誤通知" },{ id:"2" , name:"有錯誤或警告通知" },{ id:"3" , name:"完成就通知" } ] ; // MAIL通知方式

@Injectable({
  providedIn: 'root'
})
export class SyskaServicePkg extends JkEntityV2 {
  SysKa006List= SysKa006List;
  SysKa008List= SysKa008List;
  SysKa019List= SysKa019List;


  constructor() {
    super();
    this.linkMasterFields = '' ;
    this.defaultItem = new Syska();
    this.entityType.type = EntityType.data;
    this.columnLabel = { COMPANY: '公司代號', CREATOR: '建檔者代號', USR_GROUP: '群組', CREATE_DATE: '建檔日期', MODIFIER: '修改者代號', MODI_DATE: '修改日期', FLAG: '更新次數',
        KA001 : '日期' , KA002 : '時間' , KA003 : '公司代號' , KA004 : '程式代號' , KA006 : '處理進度' , KA007 : '工作電腦' , KA008 : '分類' , KA009 : '開始時間' , KA010 : '完成時間' , KA011 : '處理結果' , KA012 : '錯誤個數' , KA013 : '警告個數' , KA014 : '參數內容' , KA015 : '使用者代號' , KA016 : '定時工作代號' , KA017 : '成功筆數' , KA018 : '失敗筆數' , KA019 : 'MAIL通知方式' , KA020 : 'MAIL帳號' , NAME1 : 'API名稱'  };

    this.fieldNames = 'KA001,KA002,KA003,KA004,KA006,KA007,KA008,KA009,KA010,KA011,KA012,KA013,KA014,KA015,KA016,KA017,KA018,KA019,KA020,NAME1' ;
    this.fieldLengths = {KA001 : 8 ,KA002 : 12 ,KA003 : 30 ,KA004 : 20 ,KA006 : 1 ,KA007 : 15 ,KA008 : 20 ,KA009 : 0 ,KA010 : 0 ,KA011 : 0 ,KA012 : 8 ,KA013 : 8 ,KA014 : 300 ,KA015 : 10 ,KA016 : 14 ,KA017 : 8 ,KA018 : 8 ,KA019 : 1 ,KA020 : 255 ,NAME1 : 255 } ;
    this.columnDefs = [
      { field: "KA017", headerName: "成功筆數",headerTooltip: "",width:134,cellDataType: "number", cellStyle: { 'text-align': 'right' },  },
      { field: "KA013", headerName: "警告個數",headerTooltip: "",width:134,cellDataType: "number", cellStyle: { 'text-align': 'right' },  },
      { field: "KA014", headerName: "參數內容",headerTooltip: "",width:250,cellDataType: "text", cellEditor: 'agLargeTextCellEditor', cellRenderer: AgTextAreaEditor,  },
      { field: "KA015", headerName: "使用者代號",headerTooltip: "",width:150,cellDataType: "text", },
      { field: "KA016", headerName: "定時工作代號",headerTooltip: "",width:182,cellDataType: "text", },
      { field: "KA012", headerName: "錯誤個數",headerTooltip: "",width:134,cellDataType: "number", cellStyle: { 'text-align': 'right' },  },
      { field: "KA018", headerName: "失敗筆數",headerTooltip: "",width:134,cellDataType: "number", cellStyle: { 'text-align': 'right' },  },
      { field: "KA019", headerName: "MAIL通知方式",headerTooltip: "",width:80,cellDataType: "text", },
      { field: "KA020", headerName: "MAIL帳號",headerTooltip: "",width:250,cellDataType: "text", cellEditor: 'agLargeTextCellEditor', cellRenderer: AgTextAreaEditor,  },
      { field: "NAME1", headerName: "API名稱",headerTooltip: "",width:250,cellDataType: "text", cellEditor: 'agLargeTextCellEditor', cellRenderer: AgTextAreaEditor,  },
      { field: "KA001", headerName: "日期",headerTooltip: "",width:120,cellDataType: "text", valueFormatter: dateFormatter,  },
      { field: "KA011", headerName: "處理結果",headerTooltip: "",width:250,cellDataType: "text", },
      { field: "KA010", headerName: "完成時間",headerTooltip: "",width:80,cellDataType: "date", valueFormatter: (p:any) => { return jkLib.datetimeFormatter(p.value)},  },
      { field: "KA009", headerName: "開始時間",headerTooltip: "",width:80,cellDataType: "date", valueFormatter: (p:any) => { return jkLib.datetimeFormatter(p.value)},  },
      { field: "KA008", headerName: "分類",headerTooltip: "",width:230,cellDataType: "text", },
      { field: "KA007", headerName: "工作電腦",headerTooltip: "",width:190,cellDataType: "text", },
      { field: "KA006", headerName: "處理進度",headerTooltip: "",width:80,cellDataType: "number", cellStyle: { 'text-align': 'right' },  },
      { field: "KA004", headerName: "程式代號",headerTooltip: "",width:230,cellDataType: "text", },
      { field: "KA003", headerName: "公司代號",headerTooltip: "",width:250,cellDataType: "text", },
      { field: "KA002", headerName: "時間",headerTooltip: "",width:166,cellDataType: "text", },
    ];
    this.columnDefsVir = [
    ];
    this.tableName = 'SYSKA' ;
    this.isSys =true;
    this.sqlSelect = `SELECT SYSKA.*  FROM SYSKA` ;
    this.sqlWhereDefault = `/*WHERE*/ WHERE 1=1` ;
    this.sqlOrderDefault = ` ORDER BY KA001,KA002,KA003,KA004` ;
    this.keyFields = ['KA001','KA002','KA003','KA004'];
    this.url = '/db/crud';
    this.rememberFields = [];
    this.requiredFields = ['KA001','KA002','KA003','KA004'];
    this.seqField = '' ;
    this.seqFieldLength = 0 ;
  }
  override async validateItem(item: Syska): Promise<boolean> {
    let bool = await super.validateItem(item);
    return bool;
  }

  override async newRecord(newItem:Syska): Promise<Syska> {
  await  super.newRecord(newItem);
    return newItem;
  }




}

